import React from "react";
import { createRoot } from "react-dom/client";
import HeaderAutosuggestIsland from "./HeaderAutosuggestIsland";

const mountNode = document.getElementById("header-autosuggest-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<HeaderAutosuggestIsland config={config} />);
  }
}
